import { useQuery } from '@tanstack/react-query';

import { announcementQueries } from '../api/announcement';
import useNotificationApiInstance from './useNotificationApiInstance';

import type { UseQueryOptions } from '@tanstack/react-query';
import type { GetAnnouncementListRequest, GetAnnouncementListResponse } from '../api/announcement';

export interface UseGetAnnouncementListOptions
  extends Omit<
    UseQueryOptions<GetAnnouncementListResponse>,
    keyof ReturnType<typeof announcementQueries.list>
  > {}

const useGetAnnouncementList = (
  params?: GetAnnouncementListRequest,
  options?: UseGetAnnouncementListOptions,
) => {
  const { endpoint, instance } = useNotificationApiInstance();

  return useQuery({
    ...announcementQueries.list(instance, params),
    enabled: Boolean(endpoint),
    ...options,
  });
};

export default useGetAnnouncementList;
